import { render, staticRenderFns } from "./ResearchScatterPlot.vue?vue&type=template&id=47a1da4a"
import script from "./ResearchScatterPlot.vue?vue&type=script&lang=js"
export * from "./ResearchScatterPlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Adipose Gateway - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47a1da4a')) {
      api.createRecord('47a1da4a', component.options)
    } else {
      api.reload('47a1da4a', component.options)
    }
    module.hot.accept("./ResearchScatterPlot.vue?vue&type=template&id=47a1da4a", function () {
      api.rerender('47a1da4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/singleCellBrowser/ResearchScatterPlot.vue"
export default component.exports